<template>
  <div class="calendar-frame">
    <div class="calendar-header">
      <button @click="prev">
        <i class="fas fa-chevron-left" />
      </button>
      <div class="year-month">
        <span>{{ d[0] }}</span>
        <span>.</span>
        <span>{{ d[1] }}</span>
      </div>
      <button @click="next">
        <i class="fas fa-chevron-right" />
      </button>
    </div>

    <div>
      <div class="calendar-week">
        <div class="w-cell" v-for="ko in weeks" :key="ko">
          {{ ko }}
        </div>
      </div>
      <div>
        <div class="calendar-week">
          <div class="w-cell" v-for="dt in 7" :key="dt">
            <span :class="activate(dt - START_INDEX)">{{
              dt | firstLineCalc(START_INDEX)
            }}</span>
          </div>
        </div>
        <div class="calendar-week" v-for="(w, i) in WEEK_COUNT" :key="w">
          <div class="w-cell" v-for="dt in 7" :key="dt">
            <span :class="activate(FIRST_ROW_COUNT + dt + i * 7)">{{
              (FIRST_ROW_COUNT + dt + i * 7) | isLast(LAST_DATE)
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

function zero(num) {
  return parseInt(num.toString()) < 10 ? "0" + num : num;
}

export default {
  name: "CampaignCalendar",
  data: () => ({
    d: null,
    weeks: ["일", "월", "화", "수", "목", "금", "토"],
  }),
  props: {
    schdules: Object,
  },
  computed: {
    TODAY() {
      return dayjs();
    },

    CURRENT_WEEK() {
      if (!this.d) return 0;
      return dayjs(this.d).day();
    },

    START_INDEX() {
      if (!this.d) return 0;
      const [y, m] = this.d;
      return dayjs([y, m, 1]).day();
    },

    LAST_DATE() {
      if (!this.d) return 0;
      const [y, m] = this.d;

      return dayjs([y, m]).daysInMonth();
    },

    FIRST_ROW_COUNT() {
      return 7 - this.START_INDEX;
    },

    WEEK_COUNT() {
      return Math.ceil((this.LAST_DATE - this.FIRST_ROW_COUNT) / 7);
    },

    activate() {
      return (value) => {
        if (value > this.LAST_DATE) return null;

        if (value <= 0) return null;

        const { header, footer } = this.schdules;

        const date = `${this.d[0]}-${zero(this.d[1])}-${zero(value)}`;

        for (let i = 0; i < header.length; i++) {
          if (header[i] === footer[i] && header[i] === date) {
            return "activate circle";
          }

          if (header[i] === date) {
            return "activate header";
          }

          if (footer[i] === date) {
            return "activate footer";
          }

          if (
            dayjs(header[i]).isBefore(date) &&
            dayjs(footer[i]).isAfter(date)
          ) {
            return "activate range";
          }
        }
      };
    },
  },
  filters: {
    isLast: function(value, lastDate) {
      return value <= lastDate ? value : null;
    },

    firstLineCalc: function(value, firstOfIndex) {
      const date = value - firstOfIndex;
      return date <= 0 ? null : date;
    },
  },
  methods: {
    next() {
      const d = dayjs(this.d)
        .add(1, "month")
        .date(1);
      this.d = [d.year(), d.month() + 1, d.date()];

      this.$emit("change-date", [this.d[0], this.d[1]]);
    },

    prev() {
      const d = dayjs(this.d)
        .subtract(1, "month")
        .date(1);
      this.d = [d.year(), d.month() + 1, d.date()];

      this.$emit("change-date", [this.d[0], this.d[1]]);
    },
  },
  created() {
    const d = dayjs();
    const ymd = [d.year(), d.month() + 1, d.date()];
    this.d = ymd;
  },
};
</script>

<style lang="scss">
.calendar-frame {
  font-size: 14px;
  width: 320px;
  user-select: none;
  margin: 0 auto;
  padding: 20px 0 36px;
}

.calendar-header {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  height: 40px;
  margin-bottom: 10px;

  button {
    border-radius: 50%;
    border: none;
    outline: none;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}

.year-month {
  margin: 0 24px;
}

.calendar-week {
  display: flex;
  font-size: 13px;

  .w-cell {
    flex: 1;
    height: 40px;
    line-height: 40px;
    text-align: center;

    span {
      display: inline-block;
      position: relative;
      width: 100%;
      height: 40px;
    }

    span.activate {
      &:after {
        content: "";
        position: absolute;
        height: 30px;
        top: calc(50% - 15px);
        background-color: #cae5ff;
        z-index: -1;
      }

      &.range:after {
        width: 100%;
        left: 0;
      }

      &.circle:after {
        width: 30px;
        left: calc(50% - 15px);
        border-radius: 50%;
      }

      &.header:after {
        width: 93%;
        border-radius: 15px 0% 0% 15px;
        right: 0;
      }

      &.footer:after {
        width: 93%;
        border-radius: 0% 15px 15px 0%;
        left: 0;
      }
    }
  }
}
</style>
